module.exports = __webpack_public_path__ + "resources/img/img-acra-point-02-en.1e9f0a85b1eefb0e2bb790f9a1c95c5a.png";